import { render, staticRenderFns } from "./ConcessionariaForm.vue?vue&type=template&id=395fb43f&scoped=true&"
import script from "./ConcessionariaForm.vue?vue&type=script&lang=js&"
export * from "./ConcessionariaForm.vue?vue&type=script&lang=js&"
import style0 from "./ConcessionariaForm.vue?vue&type=style&index=0&id=395fb43f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395fb43f",
  null
  
)

export default component.exports